<footer class="footer">
  <p class="footer__text">© CCC MK HOLDINGS Co.,Ltd.</p>
</footer>
